import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { TeamToggleButtonComponent } from "./team-toggle-button.component";

@NgModule({
  declarations: [TeamToggleButtonComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [TeamToggleButtonComponent],
})
export class TeamToggleButtonModule {}
